module.exports = __webpack_public_path__ + "img/normal_multiplier_1.375e9032.png";